module.exports = __webpack_public_path__ + "media/images/icon__whatsapp@2x-4cc1a49e7cae1ce6b30f5ee311915f74.png";